/**
 * AI module route definitions — Sprint AI-MODULE v2.
 *
 * Mounted under `/modules/ai/*` by the dynamic module route loader.
 */
import { lazy } from 'react';

const AiChat = lazy(() => import('./pages/AiChat'));
const AiSettings = lazy(() => import('./pages/AiSettings'));

export const slug = 'ai';

export const routes = [
  { path: 'chat', element: AiChat },
  { path: 'chat/:threadId', element: AiChat },
  { path: 'settings', element: AiSettings },
];
